
import { Component, Input, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';

@Component({
  selector: 'content-toolbar',
  templateUrl: './content-toolbar.component.html',
  styleUrls: ['./content-toolbar.component.scss'],
  imports: [EditorModule]
})
export class ContentToolbarComponent implements AfterViewInit {
  @Input() contentFormControl!: FormControl;
  @Input() label?: string;
  editorConfig: any;

  constructor() { 
    this.editorConfig = {
    branding: false,
    menubar: false,
    plugins: ['link', 'lists'],
    base_url: '/tinymce',
    toolbar: 'fontsize bold italic underline link numlist bullist',
    setup: (editor: any) => {      
      editor.on('input', () => {
        this.contentFormControl?.setValue(editor.getContent());
      });      
      editor.on('change', () => {
        this.contentFormControl?.setValue(editor.getContent());
      });
      editor.on('ExecCommand', () => {
        this.contentFormControl?.setValue(editor.getContent());
      });
    }
  };
  }

  ngAfterViewInit(): void {
    if (this.contentFormControl?.value) {
      this.editorConfig.setup = (editor: any) => {
        editor.on('init', () => {
          editor.setContent(this.contentFormControl?.value);
        });
        editor.on('input', () => {
          this.contentFormControl?.setValue(editor.getContent());
        });
        editor.on('change', () => {
          this.contentFormControl?.setValue(editor.getContent());
        });        
        editor.on('ExecCommand', () => {
          this.contentFormControl?.setValue(editor.getContent());
        });
      };
    }
  }

  getInitialValue(): string {
    if (this.contentFormControl?.value) {
      return this.contentFormControl.value;
    } else {
      setTimeout(() => {
        if (this.contentFormControl?.value) {
          this.editorConfig.setup = (editor: any) => {
            editor.on('init', () => {
              editor.setContent(this.contentFormControl.value);
            });
            editor.on('input', () => {
              this.contentFormControl.setValue(editor.getContent());
            });            
            editor.on('change', () => {
              this.contentFormControl.setValue(editor.getContent());
            });            
            editor.on('ExecCommand', () => {
              this.contentFormControl.setValue(editor.getContent());
            });
          };
        }
      }, 500);
      return '';
    }
  }
}
